/// <reference path="../types/index.d.ts" />

import '../client_forms/oliveevents1/style.css';
import FormStructure from './oliveevents1/form_structure';

export default FormStructure;